import { List, Stack, Typography } from '@mui/material';
import { useGetApiV5FilesIdNamingSuggestions } from 'api/v5/files/files';
import { useFormContext } from 'react-hook-form';
import {
  AIFileNameSuggestionElement,
  AIFileNameSuggestionsLoadingState,
} from './components';

export interface AIFileNameSuggestionsProps {
  fileUuid: string;
  isFormLoading?: boolean;
}

export const AIFileNameSuggestions = ({
  fileUuid,
  isFormLoading,
}: AIFileNameSuggestionsProps) => {
  const { setValue } = useFormContext();
  const { data, isLoading } = useGetApiV5FilesIdNamingSuggestions(fileUuid, {
    query: {
      cacheTime: 10 * 60 * 1000 /* 10 minutes */,
      staleTime: 10 * 60 * 1000 /* 10 minutes */,
    },
  });

  const handleSuggestionClick = (selectedName: string) => {
    setValue('newFileName', selectedName, { shouldValidate: true });
  };

  return (
    <Stack gap={1}>
      <Typography variant="body1" fontWeight={600}>
        Suggested File Names
      </Typography>
      <Stack gap={2} sx={{ minHeight: '190px' }}>
        {isLoading && <AIFileNameSuggestionsLoadingState />}
        {!isLoading && (
          <List>
            {data?.suggestions?.map((suggestion) => (
              <AIFileNameSuggestionElement
                key={suggestion}
                name={suggestion}
                onClick={handleSuggestionClick}
                isLoading={isFormLoading}
              />
            ))}
          </List>
        )}
      </Stack>
    </Stack>
  );
};
